import { render } from "./MultiAutocompleteComponent.vue?vue&type=template&id=67964d0e&scoped=true"
import script from "./MultiAutocompleteComponent.vue?vue&type=script&lang=js"
export * from "./MultiAutocompleteComponent.vue?vue&type=script&lang=js"

import "./MultiAutocompleteComponent.vue?vue&type=style&index=0&id=67964d0e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67964d0e"]])

export default __exports__